import api from "./api";

class SettoriMerceologiciManager {
    settoriMerceologici(config?: any) {
        return api.get(`/settori_merceologici`, config)
    }

    settoreMerceologico(id: number | string) {
        return api.get(`/settori_merceologici/${id}`)
    }

    list = this.settoriMerceologici
    retrieve = this.settoreMerceologico
}

const settoriMerceologiciManager = new SettoriMerceologiciManager()

export default settoriMerceologiciManager
